
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { blobDownload } from '../../../../util';
import { initClient } from '../../../../api';
import { Inventory, InventoryUiClient } from '../../../backend/backendapi';

@Component({
  name: 'InventoryPrintModal',
})
export default class InventoryPrintModal extends Vue {
  inventories: Inventory[] = [];
  printQrFormat: 1 | 2 | 3 = 1;

  //api
  private readonly service = initClient(InventoryUiClient);

  public open(inventories: Inventory[]): void {
    this.inventories = inventories;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  private generateQR() {
    if (!this.inventories.length) {
      return;
    }

    this.service.generateQRCodes(this.printQrFormat, this.inventories)
        .then(response => response.data)
        .then(blob => {
          blobDownload(blob, 'qrcode.pdf');
          this.dismiss();
        });
  }
}
